import Vue from 'vue'
import VueRouter from 'vue-router'
// 保留登录、注册组件的导入
import Login from './pages/Login.vue'
import Register from './pages/Register.vue'
// 导入FineBI页面（登录后跳转的页面）
import FineBIPage from './pages/FineBIPage.vue'


Vue.use(VueRouter)

const routes = [
  // 登录路由（必须保留）
  {
    path: '/login',
    name: 'Login',
    component: Login
  },
  // 注册路由（必须保留）
  {
    path: '/register',
    name: 'Register',
    component: Register,
    beforeEnter: (to, from, next) => {
      if (localStorage.getItem('token')) {
        next('/') // 已登录用户跳首页
      } else {
        next()
      }
    }
  },
  // 首页（登录后跳转，替换原来的Home）
  {
    path: '/',
    name: 'FineBI',
    component: FineBIPage,
    meta: { requiresAuth: true } // 需要登录才能访问
  },
  // 未匹配路径重定向到登录
  {
    path: '*',
    redirect: '/login'
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

// 路由守卫（确保未登录用户只能访问登录/注册页）
router.beforeEach((to, from, next) => {
  // 判断当前路由是否需要登录权限
  if (to.matched.some(record => record.meta.requiresAuth)) {
    // 已登录则放行
    if (localStorage.getItem('token')) {
      next()
    } else {
      // 未登录跳转到登录页
      next({
        path: '/login',
        query: { redirect: to.fullPath }
      })
    }
  } else {
    // 不需要登录的页面（登录/注册）直接放行
    next()
  }
})

export default router
